<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { NCard, NButton, NSpace, NTag, NLog, NText } from 'naive-ui'
import { deployments, streams, type Deployment } from '../api'
import { message } from '../message'

const route = useRoute()
const router = useRouter()
const id = computed(() => Number(route.params.id))
const dep = ref<Deployment | null>(null)
const logBuf = ref('')
let src: EventSource | null = null

async function load() {
  try {
    dep.value = await deployments.get(id.value)
    logBuf.value = dep.value.log_blob || ''
  } catch (e: any) { message.error(e.message) }
}

onMounted(async () => {
  await load()
  src = new EventSource(streams.deployLog(id.value))
  src.onmessage = (m) => { logBuf.value += m.data + '\n' }
  src.onerror = () => { src?.close(); src = null; load() }
})
onBeforeUnmount(() => { src?.close() })

const statusType = computed(() => {
  const s = dep.value?.status
  return s === 'success' ? 'success'
    : s === 'failed' ? 'error'
    : s === 'rolled_back' ? 'warning' : 'info'
})
</script>

<template>
  <NCard>
    <NSpace align="center" justify="space-between" style="width:100%">
      <NSpace align="center">
        <NText>Deployment #{{ id }}</NText>
        <NTag v-if="dep" :type="statusType" size="small">{{ dep.status }}</NTag>
        <NText v-if="dep" depth="3">version {{ dep.version_id }}</NText>
      </NSpace>
      <NButton size="small" @click="router.back()">Back</NButton>
    </NSpace>
  </NCard>
  <NCard style="margin-top:16px">
    <NLog :log="logBuf || '(no output yet)'" :rows="30" trim />
  </NCard>
</template>
